export const scrollToElement = (element: HTMLElement | null): void => {
  if (!element) return;

  window.scrollTo({
    top: element.getBoundingClientRect().top + window.pageYOffset - 120,
    behavior: 'smooth',
  });
};


export const getErrorMessage = (key: string): string => {
  const messages: Record<string, string> = {
    firstName: 'Please enter your first name',
    lastName: 'Please enter your last name',
    email: 'Please enter your email address',
    phone: 'Please enter your phone number',
    date: 'Please select a date',
    time: 'Please select the time',
    voucherCode: 'Please enter your voucher code to continue.',
  }
  return messages[key]
}

export const validateField = ( key: string, value: string, errors: Record<string, string>) => {
  if (!value.trim()) {
    errors[key + 'Error'] = getErrorMessage(key)
    return
  }
  if (key === 'email') {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/
    if (!emailRegex.test(value)) {
      errors[key + 'Error'] = 'Please enter a valid email address'
      return
    }
  }
  if (key === 'phone') {
    const itiAvailable = !!window?.iti;
    const validValue = itiAvailable ? window.iti.isValidNumber() : true;

    const invalidCharsRegex = /[^\d\s\-+()]/g;

    if (
      invalidCharsRegex.test(value) ||
      value.length > 20 ||
      !validValue
    ) {
      errors[key + 'Error'] = 'Please enter a valid phone number';
      return;
    }
  }
  errors[key + 'Error'] = ''
}

export const validateBookingForm = (formData: any, errors: any): boolean => {
  validateField('firstName', formData.firstName, errors)
  validateField('lastName', formData.lastName, errors)
  validateField('email', formData.email, errors)
  validateField('phone', formData.phone, errors)
  return !errors.firstNameError && !errors.lastNameError && !errors.emailError && !errors.phoneError
}
